import React from "react";
import { formatujPercentoBezZnamienkaText, formatujPercentoText } from "../utils/formatovanie.js";
import { ziskajLogoBanky, ziskajStylLogaBanky } from "../utils/bankoveLoga";

function formatDatum(d) {
  if (!d) return "";

  const dt = new Date(d);
  if (Number.isNaN(dt.getTime())) return "";

  const dd = dt.getUTCDate();
  const mm = dt.getUTCMonth() + 1;
  const yyyy = dt.getUTCFullYear();

  return `${dd}.${mm}.${yyyy}`;
}



function vypisEfekty(efekt) {
  const riadky = [];

  const sadzbaTyp = String(efekt?.sadzba?.typ || "ZIADNY").toUpperCase();
  const sadzbaHodnota = efekt?.sadzba?.hodnota;

  const poplatokTyp = String(efekt?.poplatok?.typ || "ZIADNY").toUpperCase();
  const poplatokHodnota = efekt?.poplatok?.hodnota;

  if (sadzbaTyp !== "ZIADNY") {
    if (sadzbaTyp === "PEVNA" && Number.isFinite(Number(sadzbaHodnota))) {
      riadky.push(`Sadzba: pevná ${formatujPercentoBezZnamienkaText(sadzbaHodnota)}`);
    } else if (sadzbaTyp === "ZLAVA" && Number.isFinite(Number(sadzbaHodnota))) {
      riadky.push(`Sadzba: zľava ${formatujPercentoText(sadzbaHodnota)}`);
    } else {
      riadky.push(`Sadzba: ${sadzbaTyp}`);
    }
  }

  if (poplatokTyp !== "ZIADNY") {
    if (poplatokTyp === "PERCENTO" && Number.isFinite(Number(poplatokHodnota))) {
      riadky.push(`Poplatok: ${formatujPercentoBezZnamienkaText(poplatokHodnota)}`);
    } else if (poplatokTyp === "FIX" && Number.isFinite(Number(poplatokHodnota))) {
      riadky.push(`Poplatok: ${Number(poplatokHodnota).toFixed(0).replace(".", ",")} €`);
    } else {
      riadky.push(`Poplatok: ${poplatokTyp}`);
    }
  }

  return riadky;
}

function vypisPodmienky(podmienky, vsetkyTypyHypoteky) {
  const riadky = [];

  const typy = Array.isArray(podmienky?.typyHypoteky) ? podmienky.typyHypoteky.filter(Boolean) : [];

const vsetky = Array.isArray(vsetkyTypyHypoteky) ? vsetkyTypyHypoteky.filter(Boolean) : [];
const jeVsetko =
  typy.length > 0 &&
  vsetky.length > 0 &&
  typy.length === vsetky.length &&
  typy.every((t) => vsetky.includes(t));

if (typy.length && !jeVsetko) riadky.push(`Typ hypotéky: ${typy.join(", ")}`);

  const fix = Array.isArray(podmienky?.fixacieRoky)
    ? podmienky.fixacieRoky.filter((x) => x != null)
    : [];

  if (fix.length) {
    riadky.push(
      `Platí pre Fix: ${fix.join(", ")} r`
    );
  }

  const fixMesiace =
    Array.isArray(podmienky?.fixacieMesiace)
      ? podmienky.fixacieMesiace.filter(
          (x) => x != null
        )
      : [];

  if (fixMesiace.length) {
    riadky.push(
      `Atypická fixácia: ${fixMesiace.join(", ")} mes.`
    );
  }

  const ltvMax = podmienky?.ltv?.max;
  if (ltvMax != null && ltvMax !== "") riadky.push(`LTV max: ${String(ltvMax)} %`);

  const vekMin = podmienky?.vek?.min;
  const vekMax = podmienky?.vek?.max;
  const vekAplRaw = podmienky?.vek?.aplikacia;
  const vekApl = vekAplRaw && String(vekAplRaw).trim() && String(vekAplRaw).toUpperCase() !== "ZIADNA"
    ? String(vekAplRaw).trim()
    : "";

  if (vekMin != null || vekMax != null || vekApl) {
    const casti = [];
    if (vekMin != null) casti.push(`min ${vekMin}`);
    if (vekMax != null) casti.push(`max ${vekMax}`);
    if (vekApl) casti.push(vekApl);
    riadky.push(`Vek: ${casti.join(", ")}`);
  }

  const musi = Array.isArray(podmienky?.checkboxy?.podmienka?.musiaBytZapnute)
    ? podmienky.checkboxy.podmienka.musiaBytZapnute.filter(Boolean)
    : [];
  if (musi.length) riadky.push(`Podmienené: ${musi.join(", ")}`);

  return riadky;
}

export default function KampaneKarta({ bankaKod, kampane, vsetkyTypyHypoteky }) {
  const zoznam = Array.isArray(kampane) ? kampane : [];
  const logoBanky = ziskajLogoBanky(bankaKod);
  const stylLogaBanky = ziskajStylLogaBanky(logoBanky);

  return (
    <div className="porovnavac-banka-card prehlad-zp-card">
      <div className="porovnavac-banka-head">
        <div className="porovnavac-banka-nazov banka-head-with-logo">
          {logoBanky ? (
            <span
              className={`banka-logo-obal banka-logo-obal--${logoBanky.variant || "wide"}`}
              style={stylLogaBanky}
            >
              {logoBanky.srcDark ? (
                <>
                  <img
                    src={logoBanky.src}
                    alt={`${bankaKod} logo`}
                    className={`banka-logo banka-logo--light banka-logo--fit-${logoBanky.fit || "contain"}`}
                  />
                  <img
                    src={logoBanky.srcDark}
                    alt={`${bankaKod} logo`}
                    className={`banka-logo banka-logo--dark banka-logo--fit-${logoBanky.fit || "contain"}`}
                  />
                </>
              ) : (
                <img
                  src={logoBanky.src}
                  alt={`${bankaKod} logo`}
                  className={`banka-logo banka-logo--fit-${logoBanky.fit || "contain"}`}
                />
              )}
            </span>
          ) : null}

          {/* <span className="banka-head-with-logo__kod">{bankaKod}</span> */}
        </div>
      </div>

      <div>
        {zoznam.length === 0 ? (
          <div>—</div>
        ) : (
          zoznam.map((k, idx) => {
            const datumOd = formatDatum(k?.datumOd);
            const datumDoRaw = formatDatum(k?.datumDo);
            const datumDo = datumDoRaw || "neučito";

            const riadkyEfekty = vypisEfekty(k?.efekt);
            const riadkyPodmienky = vypisPodmienky(k?.podmienky, vsetkyTypyHypoteky);

            const maEfekty = riadkyEfekty.length > 0;
            const maPodmienky = riadkyPodmienky.length > 0;
            const maHint = !!(k?.hintText && String(k.hintText).trim());

            return (
              <div className="porovnavac-banka-m" key={`${bankaKod}-${idx}`}>
                <div className="k prehlad-zp-nadpis">{k?.nazov || "—"}</div>

                <div className="v prehlad-zp-obsah">
                {datumOd && (
                    <div className="note prehlad-zp-banka">
                        {datumOd} – {datumDo}
                    </div>
                    )}

                {maEfekty ? (
                  <>
                  <div className="prehlad-item-gap" />
                    <div className="k prehlad-zp-nadpis">Benefity:</div>
                    {riadkyEfekty.map((r) => (
                      <div key={r}>{r}</div>
                    ))}
                  </>
                ) : null}

                {maPodmienky ? (
                  <>
                  <div className="prehlad-item-gap" />
                    <div className="k prehlad-zp-nadpis">Podmienky</div>
                    {riadkyPodmienky.map((r) => (
                      <div key={r}>{r}</div>
                    ))}
                  </>
                ) : null}
                

                {maHint && (
                  <>
                    <div className="prehlad-item-gap" />
                    <div className="k prehlad-zp-nadpis">Poznámka:</div>
                    <div className="note">{k.hintText}</div>

                  </>
                )}
              </div>
                {idx !== zoznam.length - 1 && <div className="prehlad-item-gap" />}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}